import { render, staticRenderFns } from "./CheckInPemeriksaan.vue?vue&type=template&id=804525a4&scoped=true"
import script from "./CheckInPemeriksaan.vue?vue&type=script&lang=js"
export * from "./CheckInPemeriksaan.vue?vue&type=script&lang=js"
import style0 from "./CheckInPemeriksaan.vue?vue&type=style&index=0&id=804525a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804525a4",
  null
  
)

export default component.exports